import React from 'react';
import PropTypes from 'prop-types';
import * as SortMenuInfo from '../../../constants/K007/SortMenuInfo';
import * as SelectSortMenuModal from '../../../components/tablet/K007/SelectSortMenuModal';

/**
 * SelectRate
 */
class SelectRateSummary extends React.Component {

  constructor(props) {
    super(props);
    this.handleOptionChange = this.handleOptionChange.bind(this);
  }

  // このボックスの表示データを取得
  componentDidMount() {
    // this.props.comactions.onMountedRate();
  }

  handleOptionChange(pskubun, rateId) {
    this.props.handlePSRateChange(pskubun, rateId);
  }

  render() {
    // 表示データを生成
    const defaultValue = this.props.data.rate;
    const nodeList = this.props.rateList.map((item) => {
      let targetClass = 'filter_summary_item_switch_off';
      if (defaultValue == item.id) {
        targetClass = 'filter_summary_item_switch_on';
      }
      targetClass += ' rate_summary_item content_item_border_default';
      return (
        <span className={targetClass} key={'rate-' + item.id} onClick={() => this.handleOptionChange(item.pskubun, item.id)}>{item.display_name}</span>
      );
    });

    return (
      <div id="switchRateSummary" className="rate_summary gap_default">
        {nodeList}
      </div>
    );
  }
}

SelectRateSummary.propTypes = {
  actions: PropTypes.any.isRequired,
  comactions: PropTypes.any.isRequired,
  data: PropTypes.any.isRequired,
};

export default SelectRateSummary;
